// Función pura: no toca estado ni Formik.
export const calculateMontoPagarYMora = (
  ingresoServicio,
  fechaPago,
  mesSeleccionado, // 1..12 → por defecto es el PERIODO reportado
  anioSeleccionado,
  opciones = {}
) => {
  const {
    tasaAnual = 0.24,
    porcentajeTarifa = 0.005, // 0.5%
    mesEsPeriodoReportado = true, // <-- por defecto, el mes seleccionado es el periodo reportado
  } = opciones;

  // 0) Normalizar entrada
  const ingreso = Number.parseFloat((ingresoServicio ?? "").toString().replace(/,/g, "")) || 0;
  const mes = Number.parseInt(mesSeleccionado, 10); // 1..12
  const anio = Number.parseInt(anioSeleccionado, 10);

  // Helper: normalizar a medianoche
  const startOfDay = (d) => {
    const x = new Date(d);
    x.setHours(0, 0, 0, 0);
    return x;
  };

  // Determinar periodo reportado y fecha de vencimiento
  let reportedMonth, reportedYear, fechaVencimiento;
  if (mesEsPeriodoReportado) {
    reportedMonth = mes; // el mes seleccionado ES el reportado
    reportedYear = anio;
    fechaVencimiento = new Date(anio, mes, 10); // siempre 10 del mes siguiente
  } else {
    // Si en tu UI el mes seleccionado fuese el "mes siguiente" (mes de vencimiento)
    reportedMonth = mes === 1 ? 12 : mes - 1;
    reportedYear = mes === 1 ? anio - 1 : anio;
    fechaVencimiento = new Date(anio, mes, 10);
  }

  // 1) Tarifa por supervisión (0.5%)
  const montoPagar = Number((ingreso * porcentajeTarifa).toFixed(2));

  // 2) Aporte con reglas:
  // - Hasta ene 2025: 1%
  // - Feb 2025: prorrateado → 1–5 => 1%, 6–28 => 1.5%
  // - Mar 2025 – Mar 2026: 1.5%
  // - Abr 2026: prorrateado → 1–22 => 1.5%, 23–30 => 1%
  // - May 2026 en adelante: 1%
  const calcularMontoAporte = (ing, repMonth, repYear) => {
    if (repYear < 2025) return Number((ing * 0.01).toFixed(2));

    if (repYear === 2025) {
      if (repMonth === 1) return Number((ing * 0.01).toFixed(2));
      if (repMonth === 2) {
        // Febrero 2025 (28 días): 1–5 a 1%, 6–28 a 1.5%
        const dim = 28;
        const ingresoDiario = ing / dim;
        const parte1 = ingresoDiario * 5 * 0.01;
        const parte2 = ingresoDiario * (dim - 5) * 0.015;
        return Number((parte1 + parte2).toFixed(2));
      }
      return Number((ing * 0.015).toFixed(2)); // Mar–Dic 2025
    }

    if (repYear === 2026) {
      if (repMonth <= 3) return Number((ing * 0.015).toFixed(2)); // Ene–Mar 2026
      if (repMonth === 4) {
        // Abril 2026 (30 días): 1–22 a 1.5%, 23–30 a 1%
        const dim = 30;
        const ingresoDiario = ing / dim;
        const parte1 = ingresoDiario * 22 * 0.015;
        const parte2 = ingresoDiario * 8 * 0.01;
        return Number((parte1 + parte2).toFixed(2));
      }
      return Number((ing * 0.01).toFixed(2)); // May–Dic 2026
    }

    // 2027 en adelante
    return Number((ing * 0.01).toFixed(2));
  };

  const montoAporte = calcularMontoAporte(ingreso, reportedMonth, reportedYear);

  // 3) Mora genérica (tasa anual / 365), desde el día siguiente al vencimiento
  const calcMora = (montoBase, desde, hasta, tasa = tasaAnual) => {
    if (!desde || !hasta) return 0;
    const d = startOfDay(desde);
    const h = startOfDay(hasta);
    if (h <= d) return 0; // paga el mismo día o antes => 0
    const diffMs = h - d;
    const daysBetween = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
    const diaria = tasa / 365;
    return Number((montoBase * diaria * daysBetween).toFixed(2));
  };

  // 4) Fecha de pago u hoy
  const hoy = startOfDay(new Date());
  const fp = fechaPago ? startOfDay(new Date(fechaPago)) : hoy;

  // 5) Moras
  const mora = calcMora(montoPagar, fechaVencimiento, fp);
  const moraAporte = calcMora(montoAporte, fechaVencimiento, fp);

  return {
    montoPagar,
    mora,
    fechaVencimiento,
    montoAporte,
    moraAporte,
  };
};
